export const CONTENT_REPORTING_STEPS = {
    report: 'report',
    feedback: 'feedback',
};
